import { Button, CargoForm, CargosCandidaturasGerenciamentoList, DefaultContent } from '../components';
import { CargoResponseType, EleicaoResponseType } from '../types';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { LayoutEnum, SituacaoEleicaoEnum } from '../enums';
import { useAuthAxios, useErrorHandler, useErrorStatus, useForceReRender, useLayout } from '../hooks';
import { useNavigate, useParams } from 'react-router-dom';

import { ApiHelper } from '../helpers';
import { AxiosPromise } from 'axios';
import { Spinner } from '../utils';
import { StatusCodes } from 'http-status-codes';
import { useTranslation } from 'react-i18next';

const CargosCandidaturasGerenciamentoView: FunctionComponent = () => {
  const { idEleicao } = useParams();
  const { setErrorStatus } = useErrorStatus();
  const errorHandler = useErrorHandler();
  const { t } = useTranslation();
  const [eleicao, setEleicao] = useState<EleicaoResponseType>();
  const [cargos, setCargos] = useState<CargoResponseType[]>([]);
  const [loadingEleicao, setLoadingEleicao] = useState(true);
  const [cargoAlteracao, setCargoAlteracao] = useState<CargoResponseType>();
  const axios = useAuthAxios();
  const navigate = useNavigate();
  const { reRenderListener } = useForceReRender();
  const formEl = useRef<HTMLDivElement>(null);
  const { setLayout } = useLayout();

  useEffect(() => {
    setLayout(LayoutEnum.BASE_LAYOUT);

    if (idEleicao) {
      if (ApiHelper.isValidIntegerToApi(idEleicao)) {
        axios
          .get(ApiHelper.getUrl.apiSCE.eleicao(+idEleicao))
          .then((response) => {
            const dadosEleicao: EleicaoResponseType = response.data;
            if (dadosEleicao.situacao !== SituacaoEleicaoEnum.NAO_PUBLICADA.key) {
              navigate(`/eleicoes/${idEleicao}`);
            }
            setEleicao(response.data);

            // Carrega os cargos
            axios
              .get(ApiHelper.getUrl.apiSCE.cargos(+idEleicao!))
              .then((response) => {
                let cargos: CargoResponseType[] = response.data;
                let promises: AxiosPromise[] = [];

                cargos.forEach((cargo) =>
                  promises.push(
                    axios
                      .get(ApiHelper.getUrl.apiSCE.candidaturas(+idEleicao!, cargo.id))
                      .then((response) => (cargo.candidaturas = response.data)),
                  ),
                );

                Promise.all(promises).then(() => {
                  setCargos(cargos);
                });
              })
              .catch((error) => errorHandler(error, t('erro.recuperar_cargos')));
          })
          .catch((error) => {
            if (error.response.status === StatusCodes.NOT_FOUND) {
              setErrorStatus(error.response.status);
            } else {
              errorHandler(error, t('erro.recuperar_eleicao'));
            }
          })
          .finally(() => setLoadingEleicao(false));
      } else {
        setTimeout(() => setErrorStatus(StatusCodes.NOT_FOUND));
      }
    }
  }, []);

  useEffect(() => {
    axios.get(ApiHelper.getUrl.apiSCE.cargos(+idEleicao!)).then((response) => {
      let cargos: CargoResponseType[] = response.data;
      let promises: AxiosPromise[] = [];

      cargos.forEach((cargo) =>
        promises.push(
          axios
            .get(ApiHelper.getUrl.apiSCE.candidaturas(+idEleicao!, cargo.id))
            .then((response) => (cargo.candidaturas = response.data)),
        ),
      );
      Promise.all(promises).then(() => {
        setCargos(cargos);
      });
    });
  }, [reRenderListener]);

  return loadingEleicao ? (
    <Spinner />
  ) : (
    <DefaultContent
      title={t('label.gerenciar_cargos_candidaturas')}
      subtitle={eleicao?.titulo!}
      pageAction={<Button title={t('label.voltar')} onClick={() => navigate(`/eleicoes/${idEleicao}`)} outline />}
    >
      <div ref={formEl}>
        <CargoForm
          idEleicao={eleicao?.id!}
          cargos={cargos}
          setCargos={setCargos}
          cargoAlteracao={cargoAlteracao}
          setCargoAlteracao={setCargoAlteracao}
        />
      </div>
      <CargosCandidaturasGerenciamentoList
        idEleicao={eleicao?.id!}
        cargos={cargos}
        setCargos={setCargos}
        setCargoAlteracao={setCargoAlteracao}
        formRef={formEl}
      />
    </DefaultContent>
  );
};

export default CargosCandidaturasGerenciamentoView;
